import Actions, { errorActionConstants } from 'Redux/Actions';
import { Epic, ofType }                  from 'redux-observable';
import { mergeMap }                      from 'rxjs/operators';
import { EMPTY, from }                   from 'rxjs';
import { defaultErrorMessages }          from 'Utils';
import { message as modal }              from 'antd';
import isString                          from 'lodash/isString';

export const showErrorNotificationEpic: Epic = (action$) => {
  return action$.pipe(
    // @ts-ignore
    ofType(...errorActionConstants),
    mergeMap((action) => {

      const message = defaultErrorMessages(action.payload.error || action.payload);
      if (!!message && isString(message)) {
        modal.error(message);
        return EMPTY;
      }

      if (!message && !action.payload.data?.errors && !action.payload.data?.message) {
        return EMPTY;
      }

      // @ts-ignore
      if (message && message.hasOwnProperty('message') && !!message.message && message.message.match(/No Authorization/i)) {
        if (action.payload.error.hasOwnProperty('loginFailure')) {
          modal.error('Nutzername oder Passwort stimmen nicht überein.');
          return EMPTY;
        }
        modal.error('Autorisierungsfehler! Bitte Logge Sie sich neu ein.');
        return from([
          Actions.logout()
        ]);
      }

      if (!!action.payload.data?.errors && action.payload.data.errors[0].errorMessage) {
        modal.error(action.payload.data.errors[0].errorMessage);
        return EMPTY;
      }
      if (!!action.payload.data?.message && !!action.payload.data?.route) {
        modal.error(`${action.payload.data.message} (${action.payload.data.route})`);
        return EMPTY;
      }
      if (action.payload.data?.message) {
        modal.error(`${action.payload.data.message}`);
        return EMPTY;
      }
      if (action.payload.hasOwnProperty('message')) {
        modal.error(action.payload.message);
        return EMPTY;
      }

      // @ts-ignore
      modal.error(message?.message || message);
      return EMPTY;
    })
  );
};
